import TitleH1 from "../../Titles/title-h1";
import BookForm from "./BookForm";

const CreateBook = () => {
    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-md shadow-md">
            <TitleH1>Create Book</TitleH1>
            <BookForm/>
        </div>
    );
};

export default CreateBook;